import { useContext } from 'react'
import { ReactFinalFormContext } from 'react-final-form'
import { trackOnBlur } from 'tracking/form'

/**
 * This hook fires an onblur tracking event for fields on register modal
 */

const useTracking = name => {
  const { getFieldState } = useContext(ReactFinalFormContext)

  return function handleChange() {
    const fieldValue = getFieldState(name).value
    if (fieldValue !== undefined && fieldValue !== '') {
      const payload = { fieldValue, fieldName: name }
      return trackOnBlur(payload)
    }
  }
}

export default useTracking
